import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { CRM_RESTRICTIONS_COLUMNS } from '~/view/screens/CrmScreen/screens/CrmRestrictionsScreen/types';
import { crmRestrictionsStore } from '~/view/screens/CrmScreen/screens/CrmRestrictionsScreen/store';
import { localeStore } from '~/mobx/localesStore';
import { emptyArray } from '~/utils/helpers';

import { LoadingStatus } from '~/types/main';
import GridTable, { TGridColumnTitle } from '~/view/containers/GridTable';
import CrmRestrictionsListRow from '~/view/screens/CrmScreen/screens/CrmRestrictionsScreen/screens/CrmRestrictionsList/CrmRestrictionsListRow';
import CrmRestrictionsListRowSkeleton from '~/view/screens/CrmScreen/screens/CrmRestrictionsScreen/screens/CrmRestrictionsList/CrmRestrictionsListRowSkeleton';
import { formatImagePath } from '~/utils/formatter';
import { Icons } from '~/assets/fonts/Icons/icons';
import Pagination from '~/view/components/Controls/Pagination/Pagination';
import Preloader from '~/view/components/Controls/Preloader';

const CrmRestrictionsList = () => {
  const { isNoCrmRestrictionsFound, sorting, changeSort, loadingStatus, crmRestrictionsList, pagination, getCrmRestrictions } = crmRestrictionsStore;

  const columnTitles = useMemo((): TGridColumnTitle<CRM_RESTRICTIONS_COLUMNS>[] => {
    return [
      { title: localeStore.t('crm_restrictions_mobile_col') },
      { title: localeStore.t('crm_restrictions_payment_type_col') },
      { title: localeStore.t('crm_restrictions_comments_col') },
      { title: localeStore.t('crm_restrictions_disabled_by_col') },
      { title: localeStore.t('crm_restrictions_disabled_at_col'), columnName: CRM_RESTRICTIONS_COLUMNS.DISABLED_AT },
    ];
  }, []);

  return (
    <div className="d-flex flex-column flex-grow-1 pt-1">
      {isNoCrmRestrictionsFound ? (
        <div className="empty-list">
          <img src={formatImagePath(`${Icons.NoResults}.svg`)} alt="crm_restrictions_not_found" className="image__no-found mb-6" />
          <p className="family-medium text-size-24 color-gray2">{localeStore.t('crm_restrictions_not_found')}</p>
        </div>
      ) : (
        <GridTable
          gridTemplateClass="crm-restrictions-list-row__grid-template pr-4"
          bodyClassName="crm-restrictions-list-row__body scrollable-block__scroll_small"
          scrollClassName="crm-restrictions-scroll"
          columnTitles={columnTitles}
          filters={sorting}
          setFilters={changeSort}
        >
          {loadingStatus === LoadingStatus.Loading
            ? emptyArray().map((_, index) => <CrmRestrictionsListRowSkeleton key={'skeleton-' + String(index)} />)
            : crmRestrictionsList.map((item) => <CrmRestrictionsListRow key={item.id} data={item} />)}
        </GridTable>
      )}

      <Pagination
        visible={crmRestrictionsList.length > 0}
        className="mt-2"
        pagination={pagination}
        onChange={getCrmRestrictions}
        showPaginationInfo
      />
      <Preloader visible={loadingStatus === LoadingStatus.Loading} />
    </div>
  );
};

export default observer(CrmRestrictionsList);
